import React from "react";
import { WorkAnniversaryUsersEditorContainer } from "./styled";
import WorkAnniversaryDataBuilder from "../data/WorkAnniversaryDataBuilder";

function WorkAnniversaryEditor() {
  return (
    <WorkAnniversaryUsersEditorContainer>
      <WorkAnniversaryDataBuilder />
    </WorkAnniversaryUsersEditorContainer>
  );
}

export default WorkAnniversaryEditor;
